import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';

/**
 * Directiva para prevenir la traducción automática del navegador
 * Uso: <div appNoTranslate>contenido protegido</div>
 * o <span [appNoTranslate]>{{ fecha }}</span>
 * o simplemente: <span appNoTranslate>{{ fecha }}</span>
 */
@Directive({
  selector: '[appNoTranslate]'
})
export class NoTranslateDirective implements OnInit {

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    // Agregar atributo translate="no" para todos los navegadores
    this.renderer.setAttribute(this.el.nativeElement, 'translate', 'no');

    // Agregar clase notranslate para Google Translate
    this.renderer.addClass(this.el.nativeElement, 'notranslate');
  }
}

